class NavbarController {
  constructor() {
  }
}

export default NavbarController;



// WEBPACK FOOTER //
// ./client/app/common/navbar/navbar.controller.js